import { GetLicenseRolesRoutine } from '../redux-routines';
import type { ILicenseRoles, IPayloadAction, TLicenseRolesState } from '../interfaces';

export const initialState: TLicenseRolesState = {
  isFetching: false,
  data: {},
  error: null,
};

export const licenseRolesReducer = (
  state: TLicenseRolesState = initialState,
  action: IPayloadAction,
): TLicenseRolesState => {
  switch (action.type) {
    case GetLicenseRolesRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    case GetLicenseRolesRoutine.SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload as ILicenseRoles,
        error: null,
      };
    case GetLicenseRolesRoutine.FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload as Error,
      };
    default:
      return state;
  }
};
